import { Alert, AudioOptionInput, MediaFile } from 'models';
import { FormikHelpers } from 'formik';
import * as Yup from 'yup';

// Message.
export type MessageFormikSubmit = FormikHelpers<MessageFormFields>;

export type MessageSchemaValidation = Yup.ObjectSchema<
  Yup.Shape<object | undefined, { date: Date | undefined }>
>;

export interface MessageFormFields {
  date: string;
  text: string;
}

// Program
export type ProgramFormikSubmit = FormikHelpers<ProgramFormFields>;

export type ProgramSchemaValidation = Yup.ObjectSchema<
  Yup.Shape<object | undefined, { name: string; description: string }>
>;

export interface ProgramFormFields {
  name: string;
  description: string;
  order: number | null;
  enabled: boolean;
  isSubscriptionRequired: boolean;
  options: AudioOptionInput[] | null;
  video: MediaFile | null;
  imageURL: string | Blob;
}

export interface Notification {
  status: Alert;
  message: string;
}

export enum SubmitResult {
  SUCCESS = 'Success',
  FAILURE = 'Failure',
}

export enum Action {
  ADD = 'Add',
  UPDATE = 'Update',
  REMOVE = 'Remove',
}

export interface SelectOption {
  value: number;
  label: string;
}

export enum MediaType {
  AUDIO = 'audio',
  IMAGE = 'image',
  VIDEO = 'video',
}

export enum StorageFolder {
  AUDIO = 'audio',
  IMAGE = 'image',
  VIDEO = 'video',
}

export enum ContentType {
  JPEG = 'image/jpeg',
  WAV = 'audio/wav',
  MP4 = 'video/mp4',
}

export enum FileExtension {
  JPEG = 'jpeg',
  WAV = 'wav',
  MP4 = 'mp4',
}

export type SelectEvent = React.ChangeEvent<{
  name?: string | undefined;
  value: unknown;
}>;

export enum OrderUpdate {
  INCREMENT = 'increment',
  DECREMENT = 'decrement',
}

export enum ImageAspectRatio {
  AR_2_3 = '2/3',
  AR_9_16 = '9/16',
}

export interface UploadedImage {
  url: string;
  file: Blob;
}
